@if (!useHtml) {
  <quill-view [content]="content" format="object" theme="snow" [class.geenbuitenmarge]="geenbuitenmarge" [style.display]="inline ? 'inline-block' : 'block'"></quill-view>
} @else {
  <div #container class="sihw-editedcontainer" [class.geenbuitenmarge]="geenbuitenmarge" [style.display]="inline ? 'inline-block' : 'block'" [innerHTML]="trustedcontent"></div>
}
